import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'

const LegalNotice = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const notice = t('impressum', { returnObjects: true })
  const labels = notice.labels || {}

  const handleBackToDashboard = () => {
    // navigate('/dashboard')
    if (window.history.length > 2) {
      navigate(-1)
    } else {
      navigate('/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="border-b border-gray-800">
        <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-4">
          <button
            onClick={handleBackToDashboard}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-200"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-8 lg:py-12">
        <div className="mb-12">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 tracking-wide">
            {notice.title}
          </h1>
        </div>

        <div className="space-y-1 text-gray-200 text-sm sm:text-base leading-relaxed">
          <div>{notice.company}</div>
          <div>Musterstr. 28</div>
          <div className='mb-3'>22041 Hamburg</div>
          {/* <div><strong>{labels.street}:</strong> {notice.street}</div> */}
          {/* <div><strong>{labels.city}:</strong> {notice.city}</div> */}
          <div><strong>{labels.phone}:</strong> {notice.phone}</div>
          <div><strong>{labels.email}:</strong> {notice.email}</div>
          <div><strong>{labels.website}:</strong> {notice.website}</div>
          <div><strong>{labels.managingDirector}:</strong> {notice.managingDirector}</div>
          <div><strong>{labels.registerCourt}:</strong> {notice.registerCourt}</div>
          <div><strong>{labels.registerNumber}:</strong> {notice.registerNumber}</div>
          <div><strong>{labels.vatId}:</strong> {notice.vatId}</div>
          <div><strong>{labels.responsibleContent}:</strong> {notice.responsibleContent}</div>
          <div>
            <strong>{labels.liabilityNotice}:</strong><br />
            {notice.liabilityNotice}
          </div>
          <div>
            <strong>{labels.jurisdiction}:</strong><br />
            {notice.jurisdiction}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LegalNotice